import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: _ctx.tableData,
    border: "",
    stripe: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "颜色",
        "min-width": "60px",
        prop: "color"
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData[0]?.sizeQuantityList, (item, index) => {
        return (_openBlock(), _createBlock(_component_el_table_column, {
          "min-width": "70px",
          key: index
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.size), 1)
          ]),
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.sizeQuantityList[index].quantity), 1)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_el_table_column, {
        label: "合计",
        "min-width": "60px",
        prop: "quantity"
      }),
      _createVNode(_component_el_table_column, {
        label: "最后确认价",
        prop: "confirmPrice",
        "min-width": "86px"
      }),
      _createVNode(_component_el_table_column, {
        label: "货期",
        "min-width": "85px",
        prop: "deliveryDate"
      }, {
        default: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(row.deliveryDate, 'YYYY-MM-DD')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "客户批次",
        "min-width": "80px",
        prop: "purchaserBatch"
      }),
      _createVNode(_component_el_table_column, {
        label: "备注",
        "min-width": "120px",
        prop: "remark"
      })
    ]),
    _: 1
  }, 8, ["data"]))
}